var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 7.66016C8.16667 9.87304 6.3385 11.6668 4.08333 11.6668C1.82817 11.6668 0 9.87304 0 7.66016C0 4.15433 4.08333 0.00012207 4.08333 0.00012207C4.08333 0.00012207 8.16667 4.15404 8.16667 7.66016Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodDrop);
export default __webpack_public_path__ + "static/media/blood-drop.70d1ee72a779477d0e639832011a34cd.svg";
export { ForwardRef as ReactComponent };